import PropTypes from 'prop-types';
import React from 'react';

import LoadingCircle from '../LoadingCircle';

const SelectLoading = ({ prefix }) => {
  return (
    <div className="select-loading">
      {prefix} <LoadingCircle /> loading...
    </div>
  );
};

SelectLoading.propTypes = {
  prefix: PropTypes.string.isRequired,
};

export default SelectLoading;
